/**
 * Tracking Events
 * This file is used to track events..
 * It listens to custom events and sends the data to Shopify's analytics.
 * All data should be prepared and sent in the format that Shopify's analytics expects.
 *
 * Namespace: tracking:event-name
 */

if (typeof window !== 'undefined' && window.addEventListener) {
  window.addEventListener('klaviyoForms', function (e) {
    if (e.detail.type === 'submit') {
      Shopify.analytics.publish('klaviyoFormSubmitted');
      // eslint-disable-next-line dot-notation
      Shopify.analytics.publish('Klar:signupEvent', {email: e.detail.metaData['$email']});
    }
  });
}
